export const GET_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'GET_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const GET_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'GET_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const POST_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'POST_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const POST_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'POST_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const GET_AUTH_OFFER_HISTORY_LIST_FAILURE = 'GET_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const GET_AUTH_OFFER_HISTORY_LIST_REQUEST = 'GET_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const GET_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'GET_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const POST_AUTH_OFFER_HISTORY_LIST_FAILURE = 'POST_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const POST_AUTH_OFFER_HISTORY_LIST_REQUEST = 'POST_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const POST_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'POST_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE = 'UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST = 'UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE = 'DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST = 'DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const GET_AUTH_DESTINATION_SERVICES_FAILURE = 'GET_AUTH_DESTINATION_SERVICES_FAILURE';
export const GET_AUTH_DESTINATION_SERVICES_REQUEST = 'GET_AUTH_DESTINATION_SERVICES_REQUEST';
export const GET_AUTH_DESTINATION_SERVICES_SUCCESS = 'GET_AUTH_DESTINATION_SERVICES_SUCCESS';

export const UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE = 'UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE';
export const UPDATE_AUTH_DESTINATION_SERVICES_BUYER_REQUEST = 'UPDATE_AUTH_DESTINATION_SERVICES_BUYER_REQUEST';
export const UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS = 'UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS';

export const UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE = 'UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE';
export const UPDATE_AUTH_DESTINATION_SERVICES_RENTER_REQUEST = 'UPDATE_AUTH_DESTINATION_SERVICES_RENTER_REQUEST';
export const UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS = 'UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS';

export const UPDATE_AUTH_HOUSE_HUNTING_BUYER_FAILURE = 'UPDATE_AUTH_HOUSE_HUNTING_BUYER_FAILURE';
export const UPDATE_AUTH_HOUSE_HUNTING_BUYER_REQUEST = 'UPDATE_AUTH_HOUSE_HUNTING_BUYER_REQUEST';
export const UPDATE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS = 'UPDATE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS';

export const UPDATE_AUTH_HOUSE_HUNTING_RENTER_FAILURE = 'UPDATE_AUTH_HOUSE_HUNTING_RENTER_FAILURE';
export const UPDATE_AUTH_HOUSE_HUNTING_RENTER_REQUEST = 'UPDATE_AUTH_HOUSE_HUNTING_RENTER_REQUEST';
export const UPDATE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS = 'UPDATE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS';

export const DELETE_AUTH_HOUSE_HUNTING_BUYER_FAILURE = 'DELETE_AUTH_HOUSE_HUNTING_BUYER_FAILURE';
export const DELETE_AUTH_HOUSE_HUNTING_BUYER_REQUEST = 'DELETE_AUTH_HOUSE_HUNTING_BUYER_REQUEST';
export const DELETE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS = 'DELETE_AUTH_HOUSE_HUNTING_BUYER_SUCCESS';

export const DELETE_AUTH_HOUSE_HUNTING_RENTER_FAILURE = 'DELETE_AUTH_HOUSE_HUNTING_RENTER_FAILURE';
export const DELETE_AUTH_HOUSE_HUNTING_RENTER_REQUEST = 'DELETE_AUTH_HOUSE_HUNTING_RENTER_REQUEST';
export const DELETE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS = 'DELETE_AUTH_HOUSE_HUNTING_RENTER_SUCCESS';

export const GET_MORTGAGE_LEADS_FAILURE = 'GET_MORTGAGE_LEADS_FAILURE';
export const GET_MORTGAGE_LEADS_REQUEST = 'GET_MORTGAGE_LEADS_REQUEST';
export const GET_MORTGAGE_LEADS_SUCCESS = 'GET_MORTGAGE_LEADS_SUCCESS';

export const UPDATE_MORTGAGE_LEADS_FAILURE = 'UPDATE_MORTGAGE_LEADS_FAILURE';
export const UPDATE_MORTGAGE_LEADS_REQUEST = 'UPDATE_MORTGAGE_LEADS_REQUEST';
export const UPDATE_MORTGAGE_LEADS_SUCCESS = 'UPDATE_MORTGAGE_LEADS_SUCCESS';

export const SEND_MORTGAGE_LEADS_FAILURE = 'SEND_MORTGAGE_LEADS_FAILURE';
export const SEND_MORTGAGE_LEADS_REQUEST = 'SEND_MORTGAGE_LEADS_REQUEST';
export const SEND_MORTGAGE_LEADS_SUCCESS = 'SEND_MORTGAGE_LEADS_SUCCESS';

export const GET_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE = 'GET_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE';
export const GET_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST = 'GET_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST';
export const GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS = 'GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS';

export const UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE = 'UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_FAILURE';
export const UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST = 'UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_REQUEST';
export const UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS = 'UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS';
